module.exports = __webpack_public_path__ + "static/media/third_winner.8bf8f3f5.jpg";